import { EventEmitter, Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DataService {
  public baseUrl$ = new BehaviorSubject<string>("");
  emitWhiteLabelInfo = new EventEmitter();
  emitCustomerName = new EventEmitter();

  constructor() {}

  setBaseUrlState(url) {
    this.baseUrl$.next(url);
  }
}
